const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const {atUser} = require("../core/vault/StateCursors");
const ReportProblems = require("./ReportProblems");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			const user = atUser(vaultState).get();
			return {
				user,
			};
		},
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PagePrintStudentProblem",

		propTypes: {
			resultID: PT.number,
			blockID: PT.number,
			userID: PT.number,
			problemIndex: PT.number,
			isTrophy: PT.bool,
			forPrint: PT.bool,

			// Injected by HOCs
			user: PT.object.isRequired,
		},

		render: function() {
			// Neither account or schoolState are passed in. These only do permission
			// checks, which we skip here. If we add those later, this component
			// needs a LoadGuard for one of them and a way to figure out which one
			// is needed.
			return <ReportProblems {...this.props} />;
		},
	})
);
